import { FileArrowLeftRightOutlineIcon } from './FileArrowLeftRightOutlineIcon';

/**
 * author: Colton Wiscombe
 * id F926E7AB-0C0A-45B6-BC16-F922C8CB6BED
 * name file-arrow-left-right-outline
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-arrow-left-right-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileExchangeOutlineIcon = FileArrowLeftRightOutlineIcon;
export default FileExchangeOutlineIcon